export default "__VITE_ASSET__47999f7c__"